import { GeographicLevel } from 'app/shared/model/enumerations/geographic-level.model';

export interface IEthnicGroup {
  id?: string;
  geographicLevel?: keyof typeof GeographicLevel;
  date?: string;
  geography?: string;
  geographyCode?: string;
  totalAllUsualResidents?: number | null;
  asian?: number | null;
  black?: number | null;
  mixed?: number | null;
  white?: number | null;
  otherEthnicGroup?: number | null;
}

export const defaultValue: Readonly<IEthnicGroup> = {};
